import React from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

import useTabs from "../../../components/TabsBar/useTabs";
import TabPanel from "../../../components/TabsBar/TabPanel";
import {useStationQuery} from "../query";
import PanelInfo from "./PanelInfo";
import CardPermissions from "./CardPermissions";
import TabsBar from "../../../components/TabsBar";
import MDTypography from "../../../materialDashboard/components/MDTypography";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CardMedia from "./CardMedia";


const Station = () => {
    const {t} = useTranslation(['stations']);
    const {stationId} = useParams();

    const stationQuery = useStationQuery(parseInt(stationId));

    const tabs = useTabs({tabs: [
            {label: t("station.tabs.info"), icon: "info"},
            {label: t("station.tabs.permissions"), icon: "rule"},
            {label: t("station.tabs.media"), icon: "photo_library"}
        ]});

    const station = stationQuery.data;

    return stationQuery.isLoading ?
        null
        :
        <>
            <Container maxWidth="xxl">
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <MDTypography variant="h3" fontWeight="medium" mb={1}>
                            {t("station.title", {code: station.code})}
                        </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TabsBar {...tabs}/>
                    </Grid>
                </Grid>
                <TabPanel value={tabs.tabValue} index={0}>
                    <PanelInfo station={station}/>
                </TabPanel>
                <TabPanel value={tabs.tabValue} index={1}>
                    <CardPermissions/>
                </TabPanel>
                <TabPanel value={tabs.tabValue} index={2}>
                    <CardMedia station={station}/>
                </TabPanel>
            </Container>
        </>
}

export default Station;
